import Svg, { Path, Rect } from 'react-native-svg';
import { withDefaultIconProps, type MinimalSvgProps } from './index';

export const CheckCircle = withDefaultIconProps(
  {
    height: 15,
    width: 15,
  },
  ({ color, fillColor, ...rest }: MinimalSvgProps & { fillColor?: string }) => (
    <Svg {...rest} viewBox="0 0 15 15">
      <Rect
        height="13.2"
        rx="6.6"
        stroke={color}
        strokeWidth="1.8"
        width="13.2"
        transform={[{ translateX: 0.9 }, { translateY: 0.9 }]}
      />
      <Rect
        fill={fillColor ?? 'white'}
        height="13.2"
        rx="6.6"
        width="13.2"
        transform={[{ translateX: 0.9 }, { translateY: 0.9 }]}
      />
      <Path
        d="M6.7 10.76C6.7 10.76 6.71 10.76 6.71 10.76C6.81 10.75 6.89 10.7 6.94 10.63L10.67 4.67C10.75 4.54 10.71 4.37 10.58 4.29C10.45 4.2 10.28 4.24 10.2 4.37L6.68 9.99L4.79 7.55C4.69 7.43 4.52 7.4 4.4 7.5C4.27 7.59 4.25 7.77 4.34 7.89L6.48 10.65C6.53 10.72 6.61 10.76 6.7 10.76V10.76Z"
        fill={color}
      />
    </Svg>
  ),
);
